import styled, { css } from 'styled-components';
import { Media } from 'enums';
import { CSS_FOR_SCROLL } from 'styles/customScroll';

type Props = {
  paddingNone?: boolean;
  $open?: boolean;
};

export const MenuCategoriesStyles = styled.div<Props>`
  display: flex;
  flex-direction: column;

  background: transparent;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;

  ${({ $open, paddingNone }) =>
    $open &&
    css`
      background-color: #f5f5f4;
      border-radius: 16px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
      overflow: auto;

      ${CSS_FOR_SCROLL};

      ${paddingNone
        ? css`
            padding: 0;
          `
        : css`
            padding: 10px 40px;

            @media ${Media.mobile} {
              padding: 30px 20px;
            }

            @media ${Media.tablet} {
              padding: 30px 40px;
            }
          `}
    `}
`;
